import type {PropsWithChildren} from 'react'
import {body} from './body.module.scss'

type Props = PropsWithChildren<object>

export const Body = ({children}: Props) => <div className={body}>{children}</div>
